import { render, staticRenderFns } from "./FixationChoosePopUp.vue?vue&type=template&id=056148ce&scoped=true&"
import script from "./FixationChoosePopUp.vue?vue&type=script&lang=js&"
export * from "./FixationChoosePopUp.vue?vue&type=script&lang=js&"
import style0 from "./FixationChoosePopUp.vue?vue&type=style&index=0&id=056148ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056148ce",
  null
  
)

export default component.exports